import logo from './cardano.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <h1>
        TropicPunks
        </h1>
        <p>Get ready for the Tropic Rush!</p>
      </header>
    </div>
  );
}

export default App;
